import fetchPlus from "../lib/fetchPlus/fetchPlus";
import { Action, ActionCount, ActionComment, ActionImage } from "../types/Action";
import { ApiResponse } from "../types/API/ApiResponse";

export interface ActionCommentPost {
    actionId: string;
    comment: string;
    close: boolean;
}

const actionsService = {
    getAction: (actionId: string | number) =>
        fetchPlus<ApiResponse<"data", Action>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/actions/${actionId}`, "GET"),

    getActionComments: (actionId: string | number) =>
        fetchPlus<ApiResponse<"data", ActionComment[]>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/actions/${actionId}/comments`, "GET"),
    getActionImages: (actionId: string | number) =>
        fetchPlus<ApiResponse<"data", ActionImage[]>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/actions/${actionId}/images`, "GET"),

    addComment: (addedComment: ActionCommentPost) =>
        fetchPlus<ApiResponse<"comment", Action>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/comments`, "POST", addedComment),

    progressAction: (actionId: string | null) =>
        fetchPlus<ApiResponse<"action", Action>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/actions/${actionId}/in-progress`, "PATCH", {
            comment: "",
        }),

    closeAction: (actionId: string | null) =>
        fetchPlus<ApiResponse<"data", Action>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/actions/${actionId}/close`, "PATCH", {
            comment: "",
        }),

    getOutstandingActions: () => fetchPlus<ApiResponse<"actions", Action[]>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/actions`, "GET"),

    getOutstandingActionsCount: () =>
        fetchPlus<ApiResponse<"count", ActionCount>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/actions/count?type=OUTSTANDING`, "GET"),

    getClosedActions: () =>
        fetchPlus<ApiResponse<"actions", Action[]>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/actions?type=CLOSED`, "GET"),
};

export default actionsService;
